import { __assign, __extends } from "tslib";
import PropTypes from 'prop-types';
/* eslint-disable react/no-unused-prop-types */
import React, { Component } from 'react';
import { DragLayer as dragLayer } from 'react-dnd';
import Annotation from './Annotation';
var layerStyles = {
    position: 'fixed',
    pointerEvents: 'none',
    zIndex: 10000,
    left: 0,
    top: 0,
    width: '100%',
    height: '100%',
};
function getItemStyles(props) {
    var currentOffset = props.currentOffset, initialPointerOffset = props.initialPointerOffset, item = props.item;
    var dragOffset = {
        x: initialPointerOffset.x - item.initialPosition.left,
        y: initialPointerOffset.y - item.initialPosition.top,
    };
    var x = currentOffset.x, y = currentOffset.y;
    x += dragOffset.x;
    y += dragOffset.y;
    var transform = "translate(".concat(x, "px, ").concat(y, "px)");
    return {
        transform: transform,
        WebkitTransform: transform,
    };
}
var CustomDragLayer = /** @class */ (function (_super) {
    __extends(CustomDragLayer, _super);
    function CustomDragLayer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    // eslint-disable-next-line class-methods-use-this
    CustomDragLayer.prototype.renderItem = function (item) {
        return React.createElement(Annotation, __assign({}, item));
    };
    CustomDragLayer.prototype.render = function () {
        var _a = this.props, item = _a.item, itemType = _a.itemType, isDragging = _a.isDragging;
        if (!isDragging || itemType !== 'annotation') {
            return null;
        }
        return (React.createElement("div", { style: layerStyles },
            React.createElement("div", { style: getItemStyles(this.props) }, this.renderItem(item))));
    };
    CustomDragLayer.propTypes = {
        item: PropTypes.object,
        itemType: PropTypes.string,
        initialPointerOffset: PropTypes.shape({
            x: PropTypes.number.isRequired,
            y: PropTypes.number.isRequired,
        }),
        currentOffset: PropTypes.shape({
            x: PropTypes.number.isRequired,
            y: PropTypes.number.isRequired,
        }),
        isDragging: PropTypes.bool.isRequired,
    };
    return CustomDragLayer;
}(Component));
function collect(monitor) {
    var defaultOffset = { x: 0, y: 0 };
    return {
        item: monitor.getItem(),
        itemType: monitor.getItemType(),
        initialPointerOffset: monitor.getInitialClientOffset() || defaultOffset,
        currentOffset: monitor.getSourceClientOffset() || defaultOffset,
        isDragging: monitor.isDragging(),
    };
}
export default dragLayer(collect)(CustomDragLayer);
